import React, { useEffect } from 'react';
import { useImpressionManager } from '@fiverr-private/impressionable';
import { init as biankaClientInit } from '@fiverr-private/bianka_js';
import { getContext } from '@fiverr-private/fiverr_context';
import { LazyComponent } from '@fiverr-private/ui_utils';
import { loadBookPublishingQuestionnaireExperience } from '../loadBookPublishingQuestionnaireExperience';
import { useBookPublishingExperiment } from '../../../apps/listings/hooks/useBookPublishingExperiment';
import ListingsPerseus from '../../../apps/listings/components/ListingsPerseus';
import withRequestContext from '../../../apps/listings/components/hoc/withRequestContext';
import { ClientListingsPropTypes } from '../../../apps/listings/types';
import GenericListings from '../../../apps/listings/components/GenericListings';
import { appName } from './constants';

const ClientListings = (props) => {
    useImpressionManager();
    const { isExpertListings, bianka, dominateSubCategoryId, listingQuery } = props;
    const { queryParameters, experience } = getContext();
    const Component = isExpertListings ? GenericListings : ListingsPerseus;

    useEffect(() => {
        const init = async () => {
            await biankaClientInit(bianka.serviceUrl, appName);
        };

        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { shouldRenderBookPublishingQuestionnaire } = useBookPublishingExperiment({ dominateSubCategoryId });
    const bookPublishingBiEnrichment = {
        entrySource: queryParameters.source?.toString(),
        dominantLeafCategory: dominateSubCategoryId,
        pageName: experience.isBusiness ? 'pro_listings' : 'mp_listings',
    };

    return (
        <>
            <Component {...props} />
            {shouldRenderBookPublishingQuestionnaire && (
                <LazyComponent
                    lazyImport={loadBookPublishingQuestionnaireExperience}
                    componentProps={{
                        searchQuery: listingQuery,
                        biEnrichment: bookPublishingBiEnrichment,
                    }}
                />
            )}
        </>
    );
};

ClientListings.propTypes = ClientListingsPropTypes;

const ListingsWithRequestContext = withRequestContext(ClientListings);

export default ListingsWithRequestContext;
